module.exports = __webpack_public_path__ + "img/icon8.9e62723a.png";